
<form [formGroup]="loginForm">
    <h1>Passwort zurücksetzen</h1>
    <mat-form-field appearance="outline" >
        <mat-label>E-Mail Adresse</mat-label>
        <input matInput email type="email" formControlName="email" required placeholder="E-Mail Adresse">
    </mat-form-field>

    <div class="button-container">
        <button matRipple  mat-flat-button color="primary" [disabled]="!loginForm.valid" (click)="executeImportantAction()">
            <mat-icon aria-hidden="false">lock</mat-icon>Zurücksetzen</button>
    </div>
</form>
<div class="subtext">Du weißt dein Passwort doch? Dann kannst du <a href="#" (click)="goBack()">hier</a> zurück zum Login.</div>